import { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { logFirebaseEvent } from '@/lib/tracking';
import { useConsentStore } from '@/stores/consentStore';

interface MobileStickyCtaProps {
  appSignUpUrl: string;
}

export default function MobileStickyCta({ appSignUpUrl }: MobileStickyCtaProps) {
  const isConsentBannerOpen = useConsentStore((state) => state.isConsentBannerOpen);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setIsVisible(window.scrollY > 260);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (isConsentBannerOpen || !isVisible) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/95 p-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] backdrop-blur-md md:hidden">
      <div className="mx-auto flex max-w-xl items-center gap-2">
        <Button
          asChild
          className="h-11 flex-1 rounded-full bg-slate-900 text-white shadow-[0_10px_20px_-14px_rgba(15,23,42,0.9)] hover:bg-slate-800 focus-visible:ring-slate-300"
        >
          <a
            href={appSignUpUrl}
            onClick={() => logFirebaseEvent('marketing_cta_click', { slot: 'mobile_sticky_primary', label: 'Start Selling' })}
          >
            Start Selling
            <ArrowRight className="ml-2 h-4 w-4" />
          </a>
        </Button>
        <Button
          asChild
          variant="outline"
          className="h-11 rounded-full border-slate-300 bg-white px-4 text-slate-700 hover:border-slate-400 hover:bg-slate-50 hover:text-slate-900 focus-visible:ring-slate-300"
        >
          <a
            href="#roi-calculator"
            onClick={() => logFirebaseEvent('marketing_cta_click', { slot: 'mobile_sticky_secondary', label: 'ROI' })}
          >
            ROI
          </a>
        </Button>
      </div>
    </div>
  );
}
